import { ActionReducerMapBuilder, createSlice } from "@reduxjs/toolkit";
import { AIData, GetStartedStoreTypes, SliceStatus } from "interfaces";

import { getInitialDetails, setAIData, setInitialDetails } from "./getStartedActions";
import { initialState as initialData } from "./helper";

type getStartedSliceState = {
  initialDetails: {
    data: GetStartedStoreTypes;
    step: number;
  };
  ai: AIData;
  status: SliceStatus;
  error: string;
};

const initialState = {
  initialDetails: {
    data: initialData,
    step: 1,
    isCompleted: false
  },
  ai: {} as AIData,
  status: SliceStatus.Idle,
  error: ""
};

const getStartedSlice = createSlice({
  name: "getStarted",
  initialState,
  reducers: {},
  extraReducers: (builder: ActionReducerMapBuilder<getStartedSliceState>) =>
    builder
      .addCase(setInitialDetails, (state, action) => ({
        ...state,
        initialDetails: {
          ...state.initialDetails,
          ...action.payload
        }
      }))
      .addCase(setAIData, (state, action) => ({
        ...state,
        ai: action.payload
      }))
      .addCase(getInitialDetails.pending, state => ({
        ...state,
        status: SliceStatus.Pending
      }))
      .addCase(getInitialDetails.rejected, state => ({
        ...state,
        status: SliceStatus.Rejected
      }))
      .addCase(getInitialDetails.fulfilled, (state, action) => ({
        ...state,
        initialDetails: action.payload,
        status: SliceStatus.Resolved
      }))
      .addDefaultCase(state => state)
});

export const { reducer: getStartedReducer, name: getStartedReducerName } = getStartedSlice;

export type TGetStartedActions =
  | ReturnType<typeof setInitialDetails>
  | ReturnType<typeof setAIData>
  | ReturnType<typeof getInitialDetails>;

export const getStartedActions = {
  setInitialDetails,
  setAIData,
  getInitialDetails
};
export type GetStartedState = ReturnType<typeof getStartedReducer>;
